module.exports = __webpack_public_path__ + "194b79201ca2cb5d6a3ec64d139bc4e1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/gear.png
// module id = 2535
// module chunks = 0